var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExecutors(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37097_11439)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_37097_11439)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8696 27.0833C16.2818 27.0833 16.6875 27.1407 17.0866 27.2273C15.9166 28.8753 15.2175 30.8953 15.2175 33.0833C15.2175 33.318 15.2644 33.5407 15.3375 33.75H10.6522C10.2909 33.75 10 33.4513 10 33.0833C10 29.7753 12.6322 27.0833 15.8696 27.0833ZM34.1304 27.0833C37.3665 27.0833 40 29.7753 40 33.0833C40 33.4513 39.7078 33.75 39.3478 33.75H34.6625C34.7356 33.5407 34.7825 33.318 34.7825 33.0833C34.7825 30.8953 34.0834 28.8753 32.9134 27.2273C33.3125 27.1407 33.7182 27.0833 34.1304 27.0833ZM24.9998 24.4167C29.6746 24.4167 33.4782 28.3047 33.4782 33.0833C33.4782 33.4104 33.2473 33.6828 32.9432 33.7393L32.826 33.75H17.1736C16.8136 33.75 16.5214 33.4513 16.5214 33.0833C16.5214 28.3047 20.325 24.4167 24.9998 24.4167ZM34.1304 19.0833C35.9291 19.0833 37.3913 20.5793 37.3913 22.4167C37.3913 24.254 35.9291 25.75 34.1304 25.75C32.3316 25.75 30.8694 24.254 30.8694 22.4167C30.8694 20.5793 32.3316 19.0833 34.1304 19.0833ZM15.9616 19.0833C17.759 19.0833 19.2225 20.5793 19.2225 22.4167C19.2225 24.254 17.759 25.75 15.9616 25.75C14.1642 25.75 12.7007 24.254 12.7007 22.4167C12.7007 20.5793 14.1642 19.0833 15.9616 19.0833ZM24.9998 13.75C27.5172 13.75 29.5651 15.8433 29.5651 18.4167C29.5651 20.99 27.5172 23.0833 24.9998 23.0833C22.4824 23.0833 20.4345 20.99 20.4345 18.4167C20.4345 15.8433 22.4824 13.75 24.9998 13.75Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37097_11439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_37097_11439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    fill: "white",
    transform: "translate(10 13.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecutors);
export default __webpack_public_path__ + "static/media/executors.12cbeee877347c1438ddb14351e76a49.svg";
export { ForwardRef as ReactComponent };